import { getRequest } from "../../../../api/client";
import { getAddressPointsApi } from "../../../../Endpoints";
import { AddressPointModel } from "../models/AddressPointModel";

export const getAddressPoints = async (streetId: string) => {
  return getRequest<AddressPointModel[]>(getAddressPointsApi(streetId));
};
